// Phone numbers as E.164 (`+491701234567`), extension 3 (SMS-code login). Numbers without a
// country code are read as German (`DEFAULT_COUNTRY_CODE`). Deliberately small instead of a
// full numbering-plan library: the app only needs a stable, comparable form of the mobile
// numbers the agency stores in zvoove and employees type into the login form.

export const DEFAULT_COUNTRY_CODE = "49";

const E164 = /^\+[1-9]\d{7,14}$/;
// Countries whose numbers are often written with the national trunk zero after the country
// code ("+49 0170 …", "0049 0170 …"); it is never dialled there, so it is dropped (DACH).
const TRUNK_ZERO_COUNTRIES = ["49", "43", "41"];
// Separators people type or zvoove stores: spaces, slashes, dashes, dots, brackets.
const SEPARATORS = /[\s/\-.() ]/g;

// E.164 form of a phone number, or null when it cannot be one. Accepts `+49 170 1234567`,
// `0049 170 1234567`, `0170/1234567`, `+49 (0)170 1234567`, `+49 0170 1234567`; `49…` without
// a prefix is not guessed.
export function normalizePhone(input: string | null | undefined): string | null {
  if (!input) return null;
  // "+49 (0)170 …": the national trunk zero in brackets is not dialled after the country code.
  let s = input.trim().replace(/\(0\)/g, "").replace(SEPARATORS, "");
  if (s.startsWith("00")) s = `+${s.slice(2)}`;
  else if (s.startsWith("0")) s = `+${DEFAULT_COUNTRY_CODE}${s.slice(1)}`;
  for (const cc of TRUNK_ZERO_COUNTRIES) {
    if (s.startsWith(`+${cc}0`)) s = `+${cc}${s.slice(cc.length + 2)}`;
  }
  if (!E164.test(s)) return null;
  // German numbers: the national number (trunk zero dropped above) has at least 7 digits.
  if (s.startsWith(`+${DEFAULT_COUNTRY_CODE}`)) {
    const national = s.slice(1 + DEFAULT_COUNTRY_CODE.length);
    if (national.length < 7) return null;
  }
  return s;
}

export function isE164(value: string): boolean {
  return E164.test(value);
}
